import { render, staticRenderFns } from "./logincompany.vue?vue&type=template&id=53ce20e7&scoped=true&"
import script from "./logincompany.vue?vue&type=script&lang=js&"
export * from "./logincompany.vue?vue&type=script&lang=js&"
import style0 from "./logincompany.vue?vue&type=style&index=0&id=53ce20e7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce20e7",
  null
  
)

export default component.exports